import { render, staticRenderFns } from "./admin-nav.vue?vue&type=template&id=1915c4a0&"
var script = {}
import style0 from "./admin-nav.vue?vue&type=style&index=0&id=1915c4a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports